import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  async getUtilisateurs() {
    let utilisateurs = axios.get(
      process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_UTILISATEURS
    );
    return (await utilisateurs).data;
  },

  async updateRoles(utilisateurs) {
    let resultat = await axios.put(
      process.env.VUE_APP_BACKEND_API_URL +
        process.env.VUE_APP_URL_UTILISATEURS,
      utilisateurs
    );
    return resultat.data;
  },

  async saveUtilisateur(utilisateur) {
    let utilisateurDto = {
      nom: utilisateur.sn,
      prenom: utilisateur.givenname,
      uidLdap: utilisateur.uidLdap,
    };
    return (
      await axios.post(
        process.env.VUE_APP_BACKEND_API_URL +
          process.env.VUE_APP_URL_UTILISATEURS,
        utilisateurDto
      )
    ).data;
  },

  async deleteUtilisateur(id) {
    return (
      await axios.delete(
        process.env.VUE_APP_BACKEND_API_URL +
          process.env.VUE_APP_URL_UTILISATEURS +
          "/" +
          id
      )
    ).data;
  },
};
